/**
 * Returns `redirect` only when it points at a path on this origin, else `fallback`.
 *
 * The login page takes `?redirect=` from the URL, so anyone can craft a link that
 * sends a freshly logged-in user off-site (`//evil.com`, `/\evil.com`, `https://…`).
 * Resolving through URL applies the browser's own parsing, backslash quirks
 * included, so the origin check sees exactly what navigation would.
 */
export function safeRedirect(redirect: string | null, fallback: string, origin = window.location.origin): string {
  if (!redirect?.startsWith('/')) return fallback;
  let url: URL;
  try {
    url = new URL(redirect, origin);
  } catch {
    return fallback;
  }
  if (url.origin !== origin) return fallback;
  return url.pathname + url.search + url.hash;
}
